import { ActionContext } from 'vuex';
import { ClientState, State } from '../states';

export const reset = ({ commit }: ActionContext<ClientState, State>): void => {
  commit('reset', undefined);
};
